/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['შუაღამეს', 'შუადღ.', 'დილ.', 'ნაშუადღ.', 'საღ.', 'ღამ.'], ,
    ['შუაღამეს', 'შუადღეს', 'დილით', 'ნაშუადღევს', 'საღამოს', 'ღამით']
  ],
  [
    ['შუაღამე', 'შუადღე', 'დილა', 'ნაშუადღევი', 'საღამო', 'ღამე'],
    ,
  ],
  [
    '00:00', '12:00', ['05:00', '12:00'], ['12:00', '18:00'], ['18:00', '21:00'],
    ['21:00', '05:00']
  ]
];
